import produce from "immer";
import {
  GET_MY_SOUND,
  GET_MY_SOUND_SUCCESS,
  GET_MY_SOUND_FAIL,
  GET_TEMPLATE_TITLE,
} from "../../components/core/SoundsOfEnglish/FeatureCourse/constants";

const reducerInitialState = {
  isLoading: false,
  data: [],
  isFailed: false,
  templateTitle: " ",
};

const soundsOfEnglish = function (state = reducerInitialState, action: any) {
  switch (action.type) {
    case GET_MY_SOUND:
      return produce(state, (draftState: any) => {
        draftState.isLoading = true;
        draftState.data = [];
        draftState.isFailed = false;
      });
    case GET_MY_SOUND_SUCCESS:
      return produce(state, (draftState: any) => {
        draftState.isLoading = false;
        draftState.data = action.payload;
        draftState.isFailed = false;
      });
    case GET_MY_SOUND_FAIL:
      return produce(state, (draftState: any) => {
        draftState.isLoading = false;
        draftState.data = [];
        draftState.isFailed = true;
      });
    case GET_TEMPLATE_TITLE:
      return produce(state, (draftState: any) => {
        draftState.templateTitle = action.payload;
      });
    default:
      return state;
  }
};

export default soundsOfEnglish;
